import { Actions, createNamespace } from "../../../flux/Actions";

const ns = createNamespace('LABEL');
export const names = {
    SET: ns('SET')
};

export class LabelActions extends Actions
{
    set = (label: string, dispatchToken: string) => this.dispatch(names.SET, label, dispatchToken);
}


// WEBPACK FOOTER //
// ./src/app/flux/Label/LabelActions.ts